<template>
    <div id="app" :style="cursor">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    data: function()  {
        return {
        };
    },
    computed: {
        cursor: function()  {
            return 'cursor:' + this.$store.state.cursor;
        }
    }
}
</script>

<style src="css/bootstrap.min.css"></style>
